export default {"src":"__ASTRO_ASSET_IMAGE__p24uw0An__","width":960,"height":540,"format":"jpg"}